import styled from 'styled-components';

import { minWidth, maxWidth } from 'styles/media-queries';

import { container } from 'styles/grid';
import { sectionMargins, spacer48 } from 'styles/spacers';

export const Gallery = styled.section`
  background-color: ${props => props.theme.backgroundColor};
  color: ${props => props.theme.textColor};

  ${props => !props.fullWidth && container}
  ${sectionMargins}

  display: flex;
  flex-direction: column;
  gap: ${spacer48};
`;

export const GridContainer = styled.div`
  display: grid;
  grid-gap: 24px;

  ${minWidth.lg`
    grid-template-columns: repeat(${props => props.columns}, 1fr);
    grid-template-rows: repeat(${props => props.rows}, 1fr);
  `}
`;

export const ImageContainer = styled.img`
  width: 100%;
  height: 100%;
`;

export const Title = styled.div`
  flex-grow: 1;
`;

export const Caption = styled.p`
  flex-grow: 0;
`;

export const HeadlineContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 2rem 0;
  gap: 2rem;

  ${maxWidth.sm`
    grid-template-columns: 1fr;
  `}
`;
